var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 1.5H3.85C2.28 1.5 1 2.78 1 4.35V12.64C1 14.21 2.28 15.49 3.85 15.49H12.14C13.71 15.49 14.99 14.21 14.99 12.64V4.35C14.99 2.78 13.71 1.5 12.14 1.5H12.15ZM14.02 4.35V12.64C14.02 13.67 13.18 14.51 12.15 14.51H3.85C2.82 14.51 1.98 13.67 1.98 12.64V4.35C1.98 3.32 2.82 2.48 3.85 2.48H12.14C13.17 2.48 14.01 3.32 14.01 4.35H14.02Z",
    fill: "#8E97A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49038 8.77571C10.0418 8.31469 10.3582 7.64576 10.3582 6.9226C10.3582 5.58475 9.27343 4.5 7.93558 4.5C6.59773 4.5 5.51298 5.58475 5.51298 6.9226C5.51298 7.67288 5.84744 8.35989 6.43502 8.8209C5.1966 9.42655 4.41016 10.665 4.41016 12.0571V12.5H5.29603V12.0571C5.29603 10.5565 6.51637 9.3452 8.0079 9.3452C9.49942 9.3452 10.7198 10.5655 10.7198 12.0571V12.5H11.6056V12.0571C11.6056 10.6379 10.765 9.35424 9.49038 8.77571ZM9.4723 6.9226C9.4723 7.77232 8.7853 8.45932 7.93558 8.45932C7.08586 8.45932 6.39886 7.77232 6.39886 6.9226C6.39886 6.07288 7.08586 5.38588 7.93558 5.38588C8.7853 5.38588 9.4723 6.07288 9.4723 6.9226Z",
    fill: "#8E97A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.5559ede05d4f28cb66e09a51601719ba.svg";
export { ForwardRef as ReactComponent };